import Pattern from '@/assets/pattern.svg'
import { cn } from '@repo/ui/utils'
import { ReactNode } from 'react'

type ViewProps = {
  children?: ReactNode
  className?: string
}

export function View({ children, className }: ViewProps) {
  return (
    <div className={cn('relative h-screen', className)}>
      <div
        className="absolute inset-0 -z-0 bg-cover bg-center opacity-15"
        style={{ backgroundImage: `url(${Pattern})` }}
      />
      <div className="relative z-0 h-full">{children}</div>
    </div>
  )
}
